import { render, staticRenderFns } from "./UpdateAccessory.vue?vue&type=template&id=c0e0e060"
import script from "./UpdateAccessory.vue?vue&type=script&lang=js"
export * from "./UpdateAccessory.vue?vue&type=script&lang=js"
import style0 from "./UpdateAccessory.vue?vue&type=style&index=0&id=c0e0e060&prod&lang=css"
import style1 from "./UpdateAccessory.vue?vue&type=style&index=1&id=c0e0e060&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports